export default {
  init() {
    // JavaScript to be fired on all pages


    // $(".gfield_label").on('click', function () {
    //   $(this).closest('div').find('.ginput_container_multiselect').slideToggle();
    // });
    $(".gfield_label").on('click', function () {
      $(this).closest('div').find('.ginput_container_checkbox').slideToggle();
    });


    $('#mobile-menu-toggle').on('click', function () {
      $('#mobile-menu-panel').addClass('active');
    });

    $('#close-mobile-menu-panel').on('click', function () {
      $('#mobile-menu-panel').removeClass('active');
      setTimeout(() => {
        $('.nav-mobile .menu-item-has-children').removeClass('active');
        $('.nav-mobile .menu-item-has-children .sub-menu').addClass('close');
        $('.nav-mobile .menu-item-has-children .sub-menu').slideUp(400);
      }, 300);
    });

    $('#menu-toggle').on('click', function () {
      $('#menu-panel').addClass('active');

      $('html, body').css({
        overflow: 'hidden',
        height: '100%'
      });

      // console.log('Testing pointer event 1');
    });

    $('#close-menu-panel').on('click', function () {
      $('#menu-panel').removeClass('active');

      $('html, body').css({
        overflow: 'auto',
        height: 'auto'
      });

      // console.log('Testing pointer event 2');
    });
    // Initialise collapse for mobile nav menu
    var idx = 1;

    $('.nav-mobile .menu-item-has-children').each(function () {
      var elm = $(this);

      // Setting up collapse
      elm.find('.sub-menu').attr('id', 'mobile-submenu-' + idx);
      elm.find('.sub-menu').addClass('mobile-submenu collapse close');
      elm.find('.sub-menu').slideUp(400);

      // Setting up toggle
      elm.attr('data-target', '#mobile-submenu-' + idx);
      elm.attr('data-group', '.mobile-submenu');
      elm.attr('data-limit', 'one');
      elm.addClass('collapse-toggle mobile-submenu');

      idx++;
    });

    // Collapse ////////////////////////////////////////////////////////
    // Initialized collapse elements
    setTimeout(() => {
      $('.collapse').each(function () {
        var elm = $(this);

        if (
          elm.hasClass('show') &&
          elm.prev('.collapse-toggle').hasClass('active')
        ) {
          elm.show();
        }
      });
    }, 500);

    // When collapse toggle is clicked
    $('body').on('click', '.collapse-toggle', function () {
      var toggle = $(this);
      var group = toggle.data('group');
      var target = $(toggle.data('target'));
      var limit = toggle.data('limit');

      if (limit === 'any') {
        // target.toggleClass('close');
        target.slideToggle(400);

        toggle.toggleClass('active');
      } else {
        if (toggle.hasClass('active')) {
          toggle.removeClass('active');

          // target.addClass('close');
          target.slideUp(400);
        } else {
          $(group + '.collapse-toggle').removeClass('active');
          toggle.addClass('active');

          // $(group + '.collapse').addClass('close');
          $(group + '.collapse').slideUp(400);

          // target.removeClass('close');
          target.slideDown(400);
        }
      }

      var slickTarget = toggle.data('slick');

      if (slickTarget !== undefined) {
        var slideIndex = toggle.data('goto');

        $(slickTarget).slick('slickGoTo', parseInt(slideIndex));
      }

      var autoscroll = toggle.data('autoscroll');

      if (autoscroll) {
        setTimeout(() => {
          $('html,body').animate(
            {
              scrollTop: toggle.offset().top
            },
            1000
          );
        }, 500);
      }
    });

    // When window resize update collapse element height
    // $(window).resize(function () {
    //   $('.collapse').each(function () {
    //     var elm = $(this);

    //     if (elm.find('.collapse').length > 0 && elm.hasClass('parent-collapse')) {
    //       // is nested collapse
    //       // var totalHeight = 0;

    //       // elm.find('.collapse').each(function () {
    //       //   var child = $(this);
    //       //   totalHeight = totalHeight + child[0].scrollHeight;
    //       // });

    //       // elm[0].style.maxHeight = 'auto';
    //       // elm[0].style.maxHeight = totalHeight + 'px';

    //     } else {
    //       elm[0].style.height = 'auto';
    //       var h = elm[0].scrollHeight;
    //       elm[0].style.height = h + 'px';
    //     }
    //   });
    // });
    // Collapse //////////////////////////////////////////////////////// END

    var autoplay = true;
    // if ($('#footer-logo-carousel').data('autoplay') === 'on') { autoplay = true; }

    // Footer logo carousel
    $('.logo-carousel__list').slick({
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: true,
      arrows: false,
      autoplay: autoplay,
      autoplaySpeed: 5000,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true
          }
        }
      ]
    });

    // Image carousel
    $('.image-carousel').each(function () {
      $(this).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              arrows: false
            }
          }
        ]
      });
    });

    // Photos Slider
    $(document).on('click', function (e) {
      // on click certain dpd cards, external link will be opened in new tab
      if ($(e.target).hasClass('dpd-card_open-external-link')) {
        var elm = $(e.target);
        const link = elm.data('external-link');
        window.open(link, '_blank');
        return;
      } else if ($(e.target).hasClass('card-images')) {
        console.log('this is images card');
      } else {
        e.stopPropagation();
        return;
      }

      var elm = $(e.target);

      const id = elm.data('id');

      var data = {
        action: 'get_photos_slider',
        id: id
      };

      // Ajax call to get library posts
      $.post(window.my_ajax_object.ajax_url, data, function (payload) {
        console.log('payload', JSON.parse(payload));

        if (data.photos !== '') {
          data = JSON.parse(payload);
          $('#overlay-photos-slider').html('');
          $('#overlay-photos-slider').html(data.photos);

          $('#overlay-photos-slider').slick({
            arrows: true,
            dots: true,
            appendDots: $('#overlay-photos-dots')
          });

          $('#overlay-photos-slider').slick('slickGoTo', 0);

          if (data.description !== '') {
            $('.overlay-photos-description').show();
            $('.overlay-photos-description').html(data.description);
          } else {
            $('.overlay-photos-description').hide();
            $('.overlay-photos-description').html('');
          }

          setTimeout(() => {
            $('#overlay-photos').fadeIn(400, function () {
              $('#overlay-loader').fadeOut();
            });
          }, 200);
        }
      });
    });

    // Close photos slider overlay
    $('.close-overlay-photos').on('click', function (e) {
      if (!$(this).hasClass('fake-close-overlay')) {
        $('#overlay-photos').fadeOut(500, function () {
          $('#overlay-photos-slider').slick('unslick');
        });
      }
    });

    // Catch click event from vue js cards
    // $(document).on('click', function (event) {
    //   console.log('clicked', event.target, $(event.target).data('id'));
    // });

    if ($('.single-fake-overlay').length > 0) {
      setTimeout(() => {
        $('.single-fake-overlay .dpd-card').click();
      }, 200);
    }

    /// image grid overlay
    $('.image-grid-overlay__trigger').on('click', function (e) {
      const el = $(this);
      const galleryId = el.data('gallery');
      let images = [];

      $(`[data-gallery="${galleryId}"]`).each(function () {
        images.push($(this).data('image'));
      });

      if (images.length > 0) {
        let photos;

        images.forEach(image => {
          photos =
            photos +
            `<div><div class="overlay-photo-slide" style="background-image: url(${image})"></div></div>`;
        });

        $('.overlay-photos-description').hide();
        $('.overlay-photos-description').html('');
        $('#overlay-photos-slider').html('');
        $('#overlay-photos-slider').html(photos);

        $('#overlay-photos-slider').slick({
          arrows: true,
          dots: true,
          appendDots: $('#overlay-photos-dots')
        });

        const imgIndex = el.data('index');
        $('#overlay-photos-slider').slick('slickGoTo', imgIndex);

        setTimeout(() => {
          $('#overlay-photos').fadeIn();
        }, 200);
      }
    });

    // Tabs ///////////////
    // Init slider
    $('.tab__content-slider').each(function () {
      const id = $(this).attr('id');
      const tabAutoHeight = $(this).data('auto-height');

      var options = {
        arrows: false,
        dots: false,
        fade: true,
        adaptiveHeight:
          tabAutoHeight !== null && tabAutoHeight !== undefined
            ? tabAutoHeight
            : true,
        draggable: false,
        swipe: false,
        swipeToSlide: false,
        touchMove: false
      };

      $('#' + id).slick(options);
    });

    // Tab switch
    if ($('.tab__switch').length > 0) {
      $('.tab__switch')
        .first()
        .addClass('active');

      $('.tab__switch').on('click', function () {
        const target = $(this).data('target');
        const slideIndex = $(this).data('index');

        $(`${target}.tab__content-slider`).slick(
          'slickGoTo',
          parseInt(slideIndex)
        );

        $('.tab__switch').removeClass('active');
        $(this).addClass('active');

        // show evening show based on current tab
        $(`.evening-show`)
          .removeClass('block')
          .addClass('hidden');
        $(`.evening-show[data-slide-index='${slideIndex}']`)
          .removeClass('hidden')
          .addClass('block');
      });
    }

    // handle mobile tab switchers dropdown style
    $('.mobile-ts-toggle').on('click', function (e) {
      e.stopPropagation();
      $('.mobile-tab-switchers').removeClass('active');
      const toggleWrapper = $(this).parents('.mobile-tab-switchers');
      toggleWrapper.addClass('active');
    });

    // get the current active tab title and set it to the toggle
    $('.mobile-tab-switchers .tab__switch').on('click', function (e) {
      $(this)
        .parents('.mobile-tab-switchers')
        .children('.mobile-ts-toggle')
        .text($(this).text());
    });
    // hide all switchers on click outside it
    $(document).on('click', function (e) {
      e.stopPropagation();
      if ($(e.target).is('.mobile-tab-switchers') === false) {
        $('.mobile-tab-switchers').removeClass('active');
      }
    });
    // Tabs //////////////////////////////////////////////////////// END

    // Talent detail overlay
    $('.talent-block').on('click', function () {
      const id = $(this).data('id');

      var data = {
        action: 'query_talent_detail',
        id: id
      };

      // Ajax call to get library posts
      $.post(window.my_ajax_object.ajax_url, data, function (payload) {
        const result = JSON.parse(payload);

        // show thumbnail only if video not available
        if (result.thumbnail !== '' && result.video_id === '') {
          $('.overlay-post-thumbnail').show();
          $('.overlay-post-thumbnail').css(
            'background-image',
            'url(' + result.thumbnail + ')'
          );
        } else {
          $('.overlay-post-thumbnail').hide();
          $('.overlay-post-thumbnail').css('background-image', '');
        }

        if (result.video_id !== '') {
          $('.overlay-post-video').show();
          // $('.overlay-post-video').closest('.overlay-post-outer').find('.close-overlay').addClass('close-overlay-post-video');
        } else {
          $('.overlay-post-video').hide();
          // $('.close-overlay').removeClass('close-overlay-post-video');
        }

        if (result.title !== '') {
          $('.overlay-post-title').show();
          $('.overlay-post-title').html(result.title);
        } else {
          $('.overlay-post-title').hide();
          $('.overlay-post-title').html('');
        }

        if (result.description !== '') {
          $('.overlay-post-description').show();
          $('.overlay-post-description').html(result.description);
        } else {
          $('.overlay-post-description').hide();
          $('.overlay-post-description').html('');
        }

        setTimeout(() => {
          $('#overlay-post').fadeIn();
        }, 200);
      });
    });

    // Close post detail overlay
    $('.close-overlay-post').on('click', function () {
      $('#overlay-post').fadeOut(500, function () {
        // restore initial states if needed
      });
    });

    // Smooth scroll anchor links
    $('.anchor-link').on('click', function () {
      $('.anchor-link').removeClass('active');
      $(this).addClass('active');
      const target = $(this).data('target');

      $('html, body')
        .stop(true, false)
        .animate(
          {
            scrollTop: $(target).offset().top
          },
          1000
        );
    });

    // Masonary haventopic blocks ///////////
    if ($('#haventopics-list').length) {
      let magicGrid = new MagicGrid({
        container: '#haventopics-list',
        static: true,
        useMin: true,
        gutter: 30,
        maxColumns: 2,
        center: true
        //useTransform: false,
      });

      magicGrid.listen();
    }

    var event_page = 2;
    const btn_loadmore_event = $(
      '#event-list ~ #btn-loadmore-wrapper .btn-loadmore'
    );
    const event_max_page = $('#event-list').data('max-page');

    btn_loadmore_event.on('click', function () {
      const elm = $(this);
      const elmWrapper = $(this).parent('#btn-loadmore-wrapper');
      const loader = elm.siblings('#loader');
      var data = {
        action: 'load_event_posts_by_ajax',
        page: event_page,
        security: window.my_ajax_object.nonce,
        keyword: window.my_ajax_object.search_keyword
      };
      elm.addClass('btn-disabled');
      loader.css('visibility', 'visible');

      $.post(window.my_ajax_object.ajax_url, data, function (response) {
        if ($.trim(response) != '') {
          $('#event-list').append(response);

          if (event_page === event_max_page) {
            elmWrapper.hide();
          } else {
            event_page++;
          }
        } else {
          elmWrapper.hide();
        }
        elm.removeClass('btn-disabled');
        loader.css('visibility', 'hidden');
      });
    });

    // force autoplay video on ios
    // Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
    //   get: function () {
    //     return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
    //   },
    // });

    // const videoElement = document.getElementById('home-video');
    // $('body').on('click touchstart', function () {
    //   if (videoElement.playing) {
    //     // video is already playing so do nothing
    //   }
    //   else {
    //     // video is not playing
    //     // so play video now
    //     videoElement.play();
    //   }
    // }); $('body').click();

    var currentLang = document.querySelector(".lang-switcher");

    function updateCartLink() {
      const baseUrl = 'https://tickets.wereldhavendagen.nl';
      let newUrlCart = '';
      let newUrlAcc = '';

      if (currentLang) {
        var gtCurrentLang = currentLang.querySelector('.gt-current-lang');
        if (gtCurrentLang) {
          var whichLang = gtCurrentLang.getAttribute('data-gt-lang');
        }
      }

      switch (whichLang) {
        case 'en':
          newUrlCart = `${baseUrl}/en-GB/Cart`;
          newUrlAcc = `${baseUrl}/en-GB/Account/Manage`;
          break;
        case 'nl':
          newUrlCart = `${baseUrl}/nl-NL/Cart`;
          newUrlAcc = `${baseUrl}/nl-NL/Account/Manage`;
          break;
        default:
          newUrlCart = `${baseUrl}/nl-NL/Cart`;
          newUrlAcc = `${baseUrl}/nl-NL/Account/Manage`;
      }

      $('.ticket').each(function () {
        var subjectID = $(this).data('subjectid');
        var ticketElement = $(`.ticket[data-subjectid="${subjectID}"]`);

        if (ticketElement.length) {

          let newTix = '';

          switch (whichLang) {
            case 'en':
              newTix = `${baseUrl}/en-GB/Show/Details/` + subjectID;
              break;
            case 'nl':
              newTix = `${baseUrl}/nl-NL/Show/Details/` + subjectID;
              break;
            default:
              newTix = `${baseUrl}/nl-NL/Show/Details/` + subjectID;
          }

          var aTix = 'tix-link-' + subjectID;
          document.getElementById(aTix).href = newTix;
        }
      })

      document.getElementById('shopping-cart-link').href = newUrlCart;
      document.getElementById('account-link').href = newUrlAcc;
    }

    window.addEventListener('load', updateCartLink);
    currentLang.addEventListener('click', updateCartLink);

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // console.log('finalizing...');

    $('.desktop-nav-news').append($('#news-submenu'));
  }
};

// Responsive Ticket Dropdown section
var ticketsDiv = $(".ticket-section");
var parentID = ticketsDiv.data('parentid');
console.log("parent id in common", parentID);

if (parentID == "no") {
  $('.ticket-details').on('click', function () {
    const staggerId = $(this).data('stagger');
    const disabledTicket = $(this).hasClass('sold-out');
    // console.log($(this).hasClass('opacity-25'));

    if (disabledTicket) {
      return false;
    } else {
      const selectedTicket = $(this).parent('.ticket');
      const selectedChevron = $(this).find('.ticket-chevron');
      const selectedIframe = $(this).siblings('.ticket-purchase').find('.iframe');

      const xlAbove = $(window).outerWidth() >= 1280;
      const lgScreen =
        $(window).outerWidth() >= 1024 && $(window).outerWidth() < 1280;
      const mdScreen =
        $(window).outerWidth() >= 768 && $(window).outerWidth() < 1024;
      const mdBelow = $(window).outerWidth() < 768;

      // only 1 chevron at a time
      $('.ticket-chevron')
        .not(selectedChevron)
        .removeClass('selected');

      // only 1 ticket purchase at a time
      if (xlAbove) {
        $('.ticket')
          .not(selectedTicket)
          .css('max-height', '89px');
      } else if (lgScreen) {
        $('.ticket')
          .not(selectedTicket)
          .css('max-height', '79px');
      } else if (mdScreen) {
        $('.ticket')
          .not(selectedTicket)
          .css('max-height', '71px');
      } else if (mdBelow) {
        $('.ticket')
          .not(selectedTicket)
          .css('max-height', '69px');
      }

      if ($(selectedTicket).height() <= 89) {
        console.log('hello');

        // rotate chevron
        $(selectedChevron).addClass('selected');
        // reveal ticket purchase
        $(selectedTicket).animate({ 'max-height': '1000px' }, 300);
        console.log(selectedIframe);
        $(selectedIframe).html('<iframe data-stager-ticketshop="' + staggerId + '" height="100px" width="100%" frameborder="0" src="https://wereldhavendagen.stager.nl/web/tickets/' + staggerId + '?minimal=true" style="border: 0px; background: transparent; max-width: 100%;"></iframe>');

      } else {
        // rotate back to default
        $(selectedChevron).removeClass('selected');
        // hide ticket purchase
        if (xlAbove) {
          $(selectedTicket).animate({ 'max-height': '89px' }, 300);
        } else if (lgScreen) {
          $(selectedTicket).animate({ 'max-height': '79px' }, 300);
        } else if (mdScreen) {
          $(selectedTicket).animate({ 'max-height': '71px' }, 300);
        } else if (mdBelow) {
          $(selectedTicket).animate({ 'max-height': '69px' }, 300);
        }

      }
    }
  });
}


window.addEventListener('message', function (event) {
  // Adjust iframe height of data-stager-ticketshop based on Post Message API
  if (event.data.height) {
    var height = event.data.height;
    var identifier = event.data.identifier;
    var selector = /^[0-9]+$/.test(identifier)
      ? '[data-stager-ticketshop="' + identifier + '"]'
      : '[data-stager-ticketshop="basket"]';
    document.querySelector(selector).style.height = height + 'px';
  }

  // console.log('Checking message event: ', event.data);

  // Add numeral indicator next to shopping cart
  // If event page
  if (event.data.identifier) {
    // Add from event data
    if (event.data.tickets === 0) {
      sessionStorage.removeItem('shoppingBasket');

      $('.basket-whd')
        .text('')
        .removeClass(
          'bg-red rounded-full ml-1 p-3 h-1 w-1 flex justify-center items-center p-2 text-white text-sm'
        );
    } else {
      sessionStorage.setItem('shoppingBasket', event.data.tickets);

      $('.basket-whd')
        .text(event.data.tickets)
        .addClass(
          'bg-red rounded-full ml-1 p-3 h-1 w-1 flex justify-center items-center p-2 text-white text-sm'
        );
    }
  } else {
    // If not event page
    let sessionData = sessionStorage.getItem('shoppingBasket');

    // Add from session data
    if (sessionData) {
      $('.basket-whd')
        .text(sessionData)
        .addClass(
          'bg-red rounded-full ml-1 p-3 h-1 w-1 flex justify-center items-center p-2 text-white text-sm'
        );
    } else {
      $('.basket-whd')
        .text('')
        .removeClass(
          'bg-red rounded-full ml-1 p-3 h-1 w-1 flex justify-center items-center p-2 text-white text-sm'
        );
    }
  }
});

$('.favcard').each(function () {
  const eventFavourites = JSON.parse(localStorage.getItem('eventFavourites'));
  const postid = $(this).data('postid');

  if (eventFavourites !== null && eventFavourites !== undefined) {
    const findpostid = eventFavourites.find(id => postid === id);
    if (findpostid !== undefined) {
      $(this).addClass('favcard-active');
    }
  }
});

$('.favcard').click(function () {
  const eventFavourites = JSON.parse(localStorage.getItem('eventFavourites'));
  const postid = $(this).data('postid');

  if (eventFavourites !== null && eventFavourites !== undefined) {
    const findpostid = eventFavourites.find(id => postid === id);
    if (findpostid === undefined) {
      $(this).addClass('favcard-active');
      eventFavourites.push(postid);
    } else {
      $(this).removeClass('favcard-active');
      const index = eventFavourites.indexOf(findpostid);
      if (index > -1) {
        eventFavourites.splice(index, 1);
      }
    }

    localStorage.setItem('eventFavourites', JSON.stringify(eventFavourites));
  } else {
    localStorage.setItem('eventFavourites', JSON.stringify([postid]));
  }
});



// WEBPACK FOOTER //
// ./scripts/routes/common.js